import React, { useLayoutEffect, useRef, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import "../styles/global.css";
import "../styles/postSubmitAdvertisingEmbed.css";
import "../App.css";
import logo from "../logo2.png";

function PostSubmitThankYou() {
  const location = useLocation();
  const state = location.state || {};
  const fromCheckinSubmit = !!state.fromCheckinSubmit;
  const rootRef = useRef(null);
  const [hasGlobalNavbar, setHasGlobalNavbar] = useState(null);

  useLayoutEffect(() => {
    if (!fromCheckinSubmit) {
      return undefined;
    }
    const applyNavOffset = () => {
      const nav = document.querySelector(".navbar");
      setHasGlobalNavbar(!!nav);
      const h = nav ? Math.ceil(nav.getBoundingClientRect().height) : 0;
      rootRef.current?.style.setProperty(
        "--lb-post-submit-nav-offset",
        `${h}px`
      );
    };
    applyNavOffset();
    window.addEventListener("resize", applyNavOffset);
    return () => window.removeEventListener("resize", applyNavOffset);
  }, [fromCheckinSubmit]);

  if (!fromCheckinSubmit) {
    return <Redirect to="/" />;
  }

  return (
    <div ref={rootRef} className="content lb-post-submit-thank-you">
      {hasGlobalNavbar === false && (
        <header className="lb-post-submit-fallback-header">
          <div className="lb-post-submit-fallback-logo-link">
            <img src={logo} alt="Little Bellies Logo" />
          </div>
        </header>
      )}
      <div className="lb-post-submit-thank-you-scroll">
        <div className="container mt-2">
          <div
            className="mt-1 mb-3 lb-text-center lb-w-60 mx-auto lb-post-submit-success-card"
            data-cy="formSubmitOk"
          >
            <span className="lb-post-submit-success-icon" aria-hidden="true">
              ✓
            </span>
            <span>Your form has been submitted!</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PostSubmitThankYou;
